import { LINK } from '@constants';
import { Button } from '@viewup/ui';
import { useGlobalModalStore } from 'app/_hook';
import {
  PostCampaignCard,
  type PostCampaignCardProps,
  PostCampaignCardStatus,
  PostCampaignStatus,
  type PostingCampaignCardPointProps,
  type PostingCampaignCardSummaryProps,
  useGetPostCampaignOverview,
} from 'app/viewing/_entities/post';
import { useRouter } from 'next/navigation';

type ApplyCardProps = PostCampaignCardProps &
  PostingCampaignCardSummaryProps &
  PostingCampaignCardPointProps & {
    snsAccountUuid: string;
  };

export const ApplyCard = (props: ApplyCardProps) => {
  const router = useRouter();
  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');

  const { data: response } = useGetPostCampaignOverview(props.snsAccountUuid);
  const participatedCount =
    response?.campaigns.filter(({ status }) => status === PostCampaignStatus.APPLY_SUCCESS)
      .length || 0;

  const moveToApplyPage = async () => {
    if (participatedCount >= 3) {
      setAlertModal({
        content: `포스팅 뷰업은 3건까지 신청 가능해요.\n포스팅 제출 후 다시 참여해 주세요.`,
        onClickButton: () => {
          router.push(LINK.VIEWING_POST_OVERVIEW);
        },
        title: '포스팅을 제출해 주세요.',
      });
      return;
    }
    router.push(
      `${LINK.VIEWING_POST_APPLY}?campaign=${props.campaignUuid}&account=${props.snsAccountUuid}`,
    );
  };

  return (
    <PostCampaignCard {...props}>
      <PostCampaignCard.Point point={props.point} />
      <PostCampaignCard.Summary description={props.description} options={props.options} />
      <PostCampaignCard.Progress status={PostCampaignCardStatus.BEFORE_APPLICATION} />
      <PostCampaignCard.BottomContent>
        <Button className='applyButton' css={{ width: '100%' }} onClick={moveToApplyPage} size='M'>
          신청하기
        </Button>
      </PostCampaignCard.BottomContent>
    </PostCampaignCard>
  );
};
